// extracted by mini-css-extract-plugin
module.exports = {"section":"Roof_section__ePPuL"};